import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { routes } from 'router';
import { appService, envService } from 'services';

export const FEATURE_FLAG_KEYS = {
  // Enable/Disable the Subsidy filter in the Leisures page
  subsidyFilterEnabled: 'subsidy_filter_enabled',
  // Enable/Disable the subvention choice in the Leisure tunnel
  subventionChoiceEnabled: 'subvention_choice_enabled',
  // Enable/Disable redirection to the new travel tunnel (balance page)
  newTravelTunnelTouloisirs: 'new_travel_tunnel_touloisirs',
  // Enable/Disable sponsorship tab on the profile page
  sponsorshipEnabled: 'sponsorship_enabled'
};

/**
 * @param {string} flagKey
 * @returns {object} { enabled: boolean, isTunnelABTestLoading?: boolean }
 */
export const useFeatureFlag = (flagKey) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const featureFlags = useMemo(
    () => [
      {
        key: FEATURE_FLAG_KEYS.subsidyFilterEnabled,
        enabled: appService.isTouloisirs()
      },
      {
        key: FEATURE_FLAG_KEYS.subventionChoiceEnabled,
        enabled: appService.isArrivaj()
      },
      {
        key: FEATURE_FLAG_KEYS.newTravelTunnelTouloisirs,
        enabled: appService.isTouloisirs() ? envService.isRunningInDev() || envService.isRunningInStaging() : true
      },
      {
        key: FEATURE_FLAG_KEYS.sponsorshipEnabled,
        enabled:
          searchParams.get('sponsorship') === 'true' || location.pathname === routes.dashboard.children.sponsorship.path
      }
    ],
    [searchParams.get('sponsorship'), location.pathname]
  );

  const feature = useMemo(() => featureFlags.find((feature) => feature.key === flagKey), [featureFlags, flagKey]);

  return {
    enabled: feature?.enabled ?? false
  };
};
